import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Menu, Modal, Spin } from 'antd'
import { filterTypesEnum, FilterTypesInWords } from '../../../enum/filterType.enum'
import SimpleFilter from './components/filter-simple'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { IFilterOption, IFilterRow } from '../../../interfaces/filterProps'
import AdvanceFilter from './components/filter-advanced'
import { es_dateFormat } from 'constants/date'
import Loader from 'modules/rankmi-table/components/Loader'
import styles from './index.module.scss'

interface IFiltersModalProps {
  show: boolean
  type: string
  className?: string
  onClose: any
  translations: any
  selectedData: IFilterRow[]
  columnsData: IFilterOption[]
  onChange: any
  onDelete: any
  onAddFilterRow: any
  generalCondition: string
  onGeneralConditionChange: any
  onSubmit: any
  setFilterType: any
  onlySimpleFilters?: boolean
  dateFormat?: string
  loading?: boolean
}

const FiltersModal: React.FC<IFiltersModalProps> = ({
  show = false,
  type = 'simple',
  onClose,
  className = '',
  translations,
  selectedData,
  columnsData,
  onChange,
  onDelete,
  onAddFilterRow,
  generalCondition = 'and',
  onGeneralConditionChange,
  onSubmit,
  setFilterType,
  onlySimpleFilters = undefined,
  dateFormat = es_dateFormat,
  loading = false,
}) => {
  const { simple, advance } = filterTypesEnum
  const [lastGroup, setLastGroup] = useState(0)
  const { simple: simpleInWords, advance: advanceInWords } = FilterTypesInWords
  const [filterType, setType] = useState(type === simpleInWords ? simple : advance)

  useEffect(() => {
    setFilterType(filterType === simple ? simpleInWords : advanceInWords)
  }, [filterType])

  const handleAddRow = (group = 0) => {
    const list = document.getElementById('simpleFilters-filterContainer')
    if (list)
      setTimeout(() => {
        list.scrollTop = list.scrollHeight
      }, 100)
    onAddFilterRow(group)
  }

  return (
    <Modal
      className={`rankmiTable-filters-modal ${filterType === advance ? 'advanceFilters' : 'simpleFilters'} ${className} ${styles.container}`}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      title={filterType === simple ? translations.header : translations.advanceFilters}
      visible={show}
      onCancel={onClose}
    >
      <Spin indicator={<Loader />} spinning={loading}>
        {filterType === simple ? (
          <SimpleFilter
            columnsData={columnsData}
            dateFormat={dateFormat}
            generalCondition={generalCondition}
            selectedData={selectedData}
            translations={translations}
            onChange={onChange}
            onDelete={onDelete}
            onGeneralConditionChange={onGeneralConditionChange}
          />
        ) : (
          <AdvanceFilter
            columnsData={columnsData}
            dateFormat={dateFormat}
            selectedData={selectedData}
            setLastGroup={setLastGroup}
            translations={translations}
            onAddRow={handleAddRow}
            onChange={onChange}
            onDelete={onDelete}
          />
        )}
      </Spin>
      <div className={`${styles.modalOptions}`}>
        <a data-test="rankmiTable-filters-add-filter-condition" onClick={() => handleAddRow(filterType === simple ? lastGroup : lastGroup + 1)}>
          <FontAwesomeIcon icon={faPlus} /> {translations[filterType === simple ? 'addFilter' : 'addFilterGroup']}
        </a>
        {!onlySimpleFilters && (
          <a data-test="rankmiTable-filters-type-switch" onClick={() => setType(filterType === simple ? advance : simple)}>
            {' '}
            {translations[filterType === simple ? 'advanceFilters' : 'simpleFilters']}...{' '}
          </a>
        )}
      </div>
      {filterType === advance && (
        <div className={styles.condition}>
          {translations.advanceFilter.condition}
          <Dropdown
            className="rankmiTable-filters-advanceFilter-generalCondition"
            overlay={
              <Menu>
                <Menu.Item>
                  <a
                    className={`${styles.generalConditionSelectorOptions} rankmiTable-filters-advanceFilter-generalCondition-options`}
                    data-test="rankmiTable-filters-advancedFilter-generalCondition-and"
                    onClick={() => onGeneralConditionChange('and')}
                  >
                    <div className={styles.title}>{translations.advanceFilter.allConditions.title}</div>
                    <div className={styles.description}>{translations.advanceFilter.allConditions.description}</div>
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    className={`${styles.generalConditionSelectorOptions} rankmiTable-filters-advanceFilter-generalCondition-options`}
                    data-test="rankmiTable-filters-advancedFilter-generalCondition-or"
                    onClick={() => onGeneralConditionChange('or')}
                  >
                    <div className={styles.title}>{translations.advanceFilter.anyCondition.title}</div>
                    <div className={styles.description}>{translations.advanceFilter.anyCondition.description}</div>
                  </a>
                </Menu.Item>
              </Menu>
            }
          >
            <a className={styles.generalConditionSelector} onClick={(e) => e.preventDefault()}>
              {translations.advanceFilter[generalCondition === 'and' ? 'allConditions' : 'anyCondition'].title} <FontAwesomeIcon icon={faCaretDown} />
            </a>
          </Dropdown>
        </div>
      )}

      <Button className={styles.filterButton} data-test="rankmiTable-filters-modal-submit-btn" onClick={onSubmit}>
        <FontAwesomeIcon className="mr-2" icon={faFilter} />
        {translations.filter}
      </Button>
    </Modal>
  )
}

export default FiltersModal
